import React from "react";
import notify from "devextreme/ui/notify";
import Form, {
    SimpleItem,
    GroupItem,
    Label,
    EmptyItem,
} from "devextreme-react/form";
import "devextreme-react/text-area";
import UserInfo from "../../UserInfo";
import {
    inserirOuAtualizar,
} from "../../DataSources";
import { Button, SelectBox } from "devextreme-react";
import { criarContribuinteDs, criarLancamentoIptuDs } from "../../DataSources";
import apiAxios from "../../api-axios";
import ShowError from "../../AppServices";
import uiInfo from "../../ui-info";
import {
    Column,
    DataGrid,
    Paging,
    Pager,
    HeaderFilter,
    FilterRow,
    FormItem,
    Editing
} from 'devextreme-react/data-grid';

const template = {
    prefeituraId: undefined,
    regimeIss: 2,
    exercicio: undefined,
    qtdeParcelas: 1,
    contribuinteId: undefined,
    contribuinteNaoParticipanteId: undefined,
    dataRelancamento: undefined,
    parametroInicial: undefined,
    parametroFinal: undefined,
    relancarImoveis: false,
    naoLancarIgnorados: false,
    naoLancarSemDocumento: false,
    especialBaixio2019: false,
    tipoLancamento: 1,
    maskOption: null,
    mostrarCalculo: "none"
};

export default class IssFixo extends React.Component {
    constructor(props) {
        super(props);
        //this.veiculoDs = criarVeiculosDs();
        this.saidaProgramada = false;
        template.prefeituraId = UserInfo.getPrefeitura();
        this.ok = this.ok.bind(this);
        this.cancel = this.cancel.bind(this);
        this.state = {};
        this.lancamentoIptuDs = criarLancamentoIptuDs();

        this.onChange = this.onChange.bind(this);
        this.getNomeCodigo = this.getNomeCodigo.bind(this);
        this.onRegimeAlterado = this.onRegimeAlterado.bind(this);

        this.contribuinteOptions = {
            editorType: "dxSelectBox",
            searchEnabled: true,
            placeholder: "TODOS",
            dataSource: criarContribuinteDs(),
            valueExpr: "sequencial",
            displayExpr: "nome",
            searchMode: 'contains'
        };

        this.naoContribuinteOptions = {
            editorType: "dxSelectBox",
            searchEnabled: true,
            placeholder: "NENHUM",
            dataSource: criarContribuinteDs(),
            valueExpr: "sequencial",
            displayExpr: "nome",
            searchMode: 'contains'
        };

        this.lancamentoOptions = {
            editorType: "dxSelectBox",
            searchEnabled: false,
            dataSource: [
                { id: 1, descricao: "Todas as inscrições" },
                { id: 2, descricao: "Inscrição" },
            ],
            valueExpr: "id",
            displayExpr: "descricao",
            defaultValue: 1,
            onValueChanged: (e) => this.onChange(e),
        };

        this.regimeOptions = {
            editorType: "dxSelectBox",
            searchEnabled: false,
            dataSource: [
                { id: 1, descricao: "AUTÔNOMOS - ANUAL" },
                { id: 2, descricao: "ESTIMATIVA - MENSAL" },
                { id: 3, descricao: "SOCIEDADES DE PROFISSIONAIS - MENSAL" },
            ],
            defaultValue: 1,
            valueExpr: "id",
            displayExpr: "descricao",
            onValueChanged: (e) => this.onRegimeAlterado(e)
        };

        this.competenciaOptions = {
            editorType: "dxSelectBox",
            searchEnabled: false,
            dataSource: [
                { id: 1, descricao: "JANEIRO" },
                { id: 2, descricao: "FEVEREIRO" },
                { id: 3, descricao: "MARÇO" },
                { id: 4, descricao: "ABRIL" },
                { id: 5, descricao: "MAIO" },
                { id: 6, descricao: "JUNHO" },
                { id: 7, descricao: "JULHO" },
                { id: 8, descricao: "AGOSTO" },
                { id: 9, descricao: "SETEMBRO" },
                { id: 10, descricao: "OUTUBRO" },
                { id: 11, descricao: "NOVEMBRO" },
                { id: 12, descricao: "DEZEMBRO" },
            ],
            defaultValue: 1,
            valueExpr: "id",
            displayExpr: "descricao"
        };
    }

    getNomeCodigo(item) {
        return item ? `${item.nome} ${item.documento}` : '';
    }

    onChange(e) {
        console.log(e);
        if (e.value === 1) {
            this.setState({ tipoLancamento: e.value });
        }
        if (e.value === 2) {
            this.setState({ tipoLancamento: e.value, maskOption: "" });
        }
    }

    onRegimeAlterado(e) {
        this.setState({ regimeIss: e.value });
    }

    componentDidMount() {
        var data = new Date();
        const competencia = data.getMonth() + 1;
        const exercicio = data.getFullYear();
        console.log("competencia", competencia);
        this.setState({ ...template, competencia, exercicio, vencimento: data });
    }

    render() {
        return (
            <React.Fragment>
                <div className={"content-block dx-card responsive-paddings"}>
                    <form>
                        <Form formData={this.state} colCount={2}>
                            <GroupItem caption="CÁLCULO DE ISS FIXO" colSpan={2} colCount={2}>
                                <SimpleItem colSpan={1} dataField={"regimeIss"} editorType={"dxSelectBox"} editorOptions={this.regimeOptions}>
                                    <Label text="Regime" />
                                </SimpleItem>
                            </GroupItem>

                            <GroupItem caption="INFORMAÇÕES DA COBRANÇA" colSpan={2} colCount={3} visible={this.state.regimeIss != 1}>
                                <SimpleItem colSpan={1} dataField={"competencia"} editorType={"dxSelectBox"} editorOptions={this.competenciaOptions}>
                                    <Label text="Competência" />
                                </SimpleItem>
                                <SimpleItem colSpan={1} dataField={"exercicio"} editorType={"dxNumberBox"} editorOptions={{ format: uiInfo.formatoNumerico.inteiroSemPonto }}>
                                    <Label text="Exercício" />
                                </SimpleItem>
                                <SimpleItem colSpan={1} dataField={"vencimento"} editorType={"dxDateBox"} editorOptions={{ width: "100%", useMaskBehavior: true }}>
                                    <Label text="Vencimento" />
                                </SimpleItem>
                            </GroupItem>

                            <GroupItem caption="INFORMAÇÕES DA COBRANÇA" colSpan={2} colCount={3} visible={this.state.regimeIss == 1}>
                                <SimpleItem colSpan={1} dataField={"exercicio"} editorType={"dxNumberBox"} editorOptions={{ format: uiInfo.formatoNumerico.inteiroSemPonto }}>
                                    <Label text="Exercício" />
                                </SimpleItem>
                                <SimpleItem colSpan={1} dataField={"qtdeParcelas"} editorType={"dxNumberBox"} editorOptions={{ format: uiInfo.formatoNumerico.inteiroSemPonto }}>
                                    <Label text="Qtde. Parcelas" />
                                </SimpleItem>
                                <SimpleItem colSpan={1} dataField={"vencimento"} editorType={"dxDateBox"} editorOptions={{ width: "100%", useMaskBehavior: true }}>
                                    <Label text="Vencimento 1ª Parcela" />
                                </SimpleItem>
                            </GroupItem>

                            <GroupItem caption="Tipo de Filtros" colSpan={2} colCount={4}>
                                <SimpleItem
                                    dataField={"tipoLancamento"}
                                    editorType={"dxSelectBox"}
                                    editorOptions={this.lancamentoOptions}
                                    colSpan={2}
                                >
                                    <Label text="Tipo de Lançamento" />
                                </SimpleItem>
                                <EmptyItem colSpan={2} />
                            </GroupItem>
                            {this.state.tipoLancamento == 1 ? null : (
                                <GroupItem caption="Parâmetros" colSpan={2} colCount={4}>
                                    <SimpleItem
                                        editorOptions={{ mask: this.state.maskOption }}
                                        colSpan={2}
                                        dataField={"parametroInicial"}
                                    >
                                        <Label text="De" />
                                    </SimpleItem>
                                    <EmptyItem colSpan={2} />
                                    <SimpleItem
                                        editorOptions={{ mask: this.state.maskOption }}
                                        colSpan={2}
                                        dataField={"parametroFinal"}
                                    >
                                        <Label text="Até" />
                                    </SimpleItem>
                                    <EmptyItem colSpan={2} />
                                </GroupItem>
                            )}
                        </Form>
                        <div style={{ marginTop: "10px" }}>
                            <div style={{ display: "inline-block" }}>
                                <Button
                                    width={120}
                                    text="Calcular"
                                    type="success"
                                    onClick={this.ok}
                                />
                            </div>
                            <div style={{ display: "inline-block", marginLeft: "10px", display: "none" }}>
                                <Button text="Cancelar" onClick={this.cancel} />
                            </div>
                            <div style={{ display: this.mostrarCalculo }}>
                                <h3>Resultado cálculos</h3>
                                <DataGrid
                                    dataSource={this.state.calculosIss}
                                    showBorders={true}
                                    rowAlternationEnabled={true}
                                    remoteOperations={true}
                                    focusedRowEnabled={true}
                                    wordWrapEnabled={true}
                                    onInitNewRow={this.initNewRow}
                                    keyExpr={"cpbsId"}
                                    >
                                    <Editing mode={"row"} allowAdding={false} allowUpdating={false} allowDeleting={false} useIcons={true} />
                                    <Column dataField={'sucesso'} caption={"Sucesso"} width={'200'} />
                                    <Column dataField={'inscricao'} caption={"Inscrição"} width={'200'} />
                                    <Column dataField={'valor'}
                                        caption={"Valor"}
                                        dataType={"number"}
                                        editorType={"dxNumberBox"}
                                        format={"#,##0.00"}
                                        editorOptions={{ format: "#,##0.000000" }} />
                                    <Column dataField={'regimeStr'} caption={"Regime"} width={'200'} />

                                    <Column dataField={'nome'} caption={"Nome"} />
                                    <Column dataField={'competenciaStr'} caption={"Competência"} />


                                    {/* <Column dataField={'prefeituraId'} caption={"Prefeitura"} visible={false}>
                                        <FormItem visible={false}></FormItem>
                                    </Column>
                                    <Column dataField={'descricao'} caption={"Descrição"} />
                                    <Column
                                        dataField={'dataInicioVigencia'}
                                        dataType={'date'}
                                        caption={"Início Vigência"}
                                        editorType={"dxDateBox"}
                                        editorOptions={{ useMaskBehavior: true }} />
                                    <Column
                                        dataField={'dataFimVigencia'}
                                        dataType={'date'}
                                        caption={"Fim Vigência"}
                                        editorType={"dxDateBox"}
                                        editorOptions={{ useMaskBehavior: true }} />
                                    <Column dataField={'valor'}
                                        caption={"Valor"}
                                        dataType={"number"}
                                        editorType={"dxNumberBox"}
                                        format={"#,##0.000000"}
                                        editorOptions={{ format: "#,##0.000000" }} /> */}
                                    <Paging defaultPageSize={uiInfo.tamanhoPaginaPadrao} />
                                    <Pager
                                        showPageSizeSelector={true}
                                        allowedPageSizes={uiInfo.tamanhoPaginaOpcoes}
                                    />
                                </DataGrid>
                            </div>
                        </div>
                    </form>
                </div>
            </React.Fragment >
        );
    }

    ok() {
        const entidade = { ...this.state, prefeituraId: UserInfo.getPrefeitura() };
        console.log("dto sendo enviado", entidade);
        apiAxios
            .post(`/lancamentos/calcular_iss_fixo/${UserInfo.getPrefeitura()}`, entidade)
            .then(response => {
                console.log("response data", response);
                console.log("data", response.data)
                this.setState({ calculosIss: response.data, mostrarCalculo: "block" });
            })
            .catch(function (error) {
                if (error.response && error.response.data && error.response.data.erros) {
                    ShowError(error.response.data.erros);
                }
                else {
                    ShowError(error.message);
                }
            });
    }

    cancel() {
        notify("Operação cancelada", "warning");
        this.props.history.goBack();
    }
}
